import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, Typography, Autocomplete, TextField, DialogActions, Alert } from '@mui/material';
import { CloseSquare } from 'iconsax-react';

const AcceptModal = ({ show, setShow, uiStore, notification }) => {
    const { userCards, error } = uiStore
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState(userCards?.map(i => ({ label: i.name, value: i._id })))

    const confirm = async () => {
        setLoading(true);
        const res = await uiStore.acceptRequest(notification, cards.map(i => i.value));
        if (res) {
            setShow(false);
        }
        setLoading(false);
    };

    useEffect(() => { 
        setCards(notification.profilesRequested.map(i => ({ label: i.name, value: i._id })))
    }, [notification])

    useEffect(() => { 
        setOptions(userCards?.filter(i => !cards.find(k => k.value === i._id)).map(i => ({ label: i.name, value: i._id })))

    }, [cards, userCards])

    

    return (
        <Dialog open={show} onClose={() => setShow(false)}
            PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
        >
            <DialogTitle>
                Sync Request
                <IconButton
                    aria-label="close"
                    onClick={() => setShow(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseSquare
                        size="30"
                        variant="Bulk"
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                {error &&
                    <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                }

                <Typography>Choose the profiles you would like <b>{notification.requestingProfiles[0]?.FirstName?.infoValue}</b> to access:</Typography>
                <Autocomplete
                    multiple
                    sx={{ mt: 3, mb: 3 }}
                    renderInput={(params) => <TextField label='Cards' {...params} />}
                    options={options}
                    value={cards}
                    onChange={(e, value) => setCards(value)}
                    filterSelectedOptions
                />
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                    Cancel
                </LoadingButton>
                <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                    Accept
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default AcceptModal;